export const SET_AUTO_TOP_UP_STORE = "SET_AUTO_TOP_UP_STORE";
export const SET_AUTO_TOP_UP_RESET = "SET_AUTO_TOP_UP_RESET";

// Lấy danh sách đã đăng ký Auto TopUp
export const FETCH_AUTO_TOP_UP_LIST_REQUEST = "FETCH_AUTO_TOP_UP_LIST_REQUEST";
export const FETCH_AUTO_TOP_UP_LIST_SUCCESS = "FETCH_AUTO_TOP_UP_LIST_SUCCESS";
export const FETCH_AUTO_TOP_UP_LIST_FAILURE = "FETCH_AUTO_TOP_UP_LIST_FAILURE";

// Huỷ đăng ký Auto TopUp
export const FETCH_AUTO_TOP_UP_DELETE_REQUEST = "FETCH_AUTO_TOP_UP_DELETE_REQUEST";
export const FETCH_AUTO_TOP_UP_DELETE_SUCCESS = "FETCH_AUTO_TOP_UP_DELETE_SUCCESS";
export const FETCH_AUTO_TOP_UP_DELETE_FAILURE = "FETCH_AUTO_TOP_UP_DELETE_FAILURE";

// Lấy Danh sách nhà mạng
export const FETCH_AUTO_TOP_UP_LIST_PROVIDER_REQUEST = "FETCH_AUTO_TOP_UP_LIST_PROVIDER_REQUEST";
export const FETCH_AUTO_TOP_UP_LIST_PROVIDER_SUCCESS = "FETCH_AUTO_TOP_UP_LIST_PROVIDER_SUCCESS";
export const FETCH_AUTO_TOP_UP_LIST_PROVIDER_FAILURE = "FETCH_AUTO_TOP_UP_LIST_PROVIDER_FAILURE";

// Check số điên thoại đã đăng ký chưa
export const FETCH_AUTO_TOP_UP_VALID_PHONE_REQUEST = "FETCH_AUTO_TOP_UP_VALID_PHONE_REQUEST";
export const FETCH_AUTO_TOP_UP_VALID_PHONE_SUCCESS = "FETCH_AUTO_TOP_UP_VALID_PHONE_SUCCESS";
export const FETCH_AUTO_TOP_UP_VALID_PHONE_FAILURE = "FETCH_AUTO_TOP_UP_VALID_PHONE_FAILURE";

// Xác nhận
export const FETCH_AUTO_TOP_UP_CREATE_REQUEST = "FETCH_AUTO_TOP_UP_CREATE_REQUEST";
export const FETCH_AUTO_TOP_UP_CREATE_SUCCESS = "FETCH_AUTO_TOP_UP_CREATE_SUCCESS";
export const FETCH_AUTO_TOP_UP_CREATE_FAILURE = "FETCH_AUTO_TOP_UP_CREATE_FAILURE";

// Xác thực
export const FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_REQUEST = "FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_REQUEST";
export const FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_SUCCESS = "FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_FAILURE = "FETCH_AUTO_TOP_UP_AUTHORIZATION_KEY_FAILURE";

// Lấy lịch sử giao dịch Auto TopUp
export const FETCH_AUTO_TOP_UP_TRANSACTION_REQUEST = "FETCH_AUTO_TOP_UP_TRANSACTION_REQUEST";
export const FETCH_AUTO_TOP_UP_TRANSACTION_SUCCESS = "FETCH_AUTO_TOP_UP_TRANSACTION_SUCCESS";
export const FETCH_AUTO_TOP_UP_TRANSACTION_FAILURE = "FETCH_AUTO_TOP_UP_TRANSACTION_FAILURE";
